import { render, staticRenderFns } from "./PopupProfileSave.vue?vue&type=template&id=1f820a60&scoped=true"
import script from "./PopupProfileSave.vue?vue&type=script&lang=js"
export * from "./PopupProfileSave.vue?vue&type=script&lang=js"
import style0 from "./PopupProfileSave.vue?vue&type=style&index=0&id=1f820a60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f820a60",
  null
  
)

export default component.exports